import React, {useState, useEffect} from 'react';
import {Helmet} from "react-helmet";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import Navigation from "../partials/Navigation";
import ChartGenerator from '../partials/PieChartGenerator/ChartGenerator';
import { useCookies } from "react-cookie";
import configVars from "../config";
import { getWithExpiry, setWithExpiry } from '../common';
import jwt_decode from "jwt-decode";
import { useParams, Link } from 'react-router-dom';


const PieCharts = () => {

	const [cookies] = useCookies(["sustainyou_user_jwt"]);
	const [loading, setLoading] = useState(false);
	const [userCharts, setUserCharts] = useState([]);
	const { chart_id } = useParams();

	useEffect(() => {

		if ( ! cookies.sustainyou_user_jwt ) {
            return;
        }

		const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);

		if ( !jwtDecoded.id ) return;

		const savedCharts = getWithExpiry( `user_pie_charts_${jwtDecoded.id}` );

		if ( savedCharts ) {
			setUserCharts( savedCharts );
		} else {

			(async () => {

				let userRequestData = new FormData();
				userRequestData.append( 'token', cookies.sustainyou_user_jwt );
	
				setLoading(true);
	
				const fetchUrl = `${configVars.apiUrl}sustainchange/v1/getpiecharts/`;
	
				try{
	
					const response = await fetch(
						fetchUrl,
						{
						method: "POST",
						headers: {
							Authorization: `Basic ${configVars.auth}`,
						},
						body: userRequestData
						}
					);
					
					const updateResponse = await response.json();
			
					if ( updateResponse ) {
	
						if ( updateResponse.success === true ) {
							
							setUserCharts( updateResponse.data.user_charts );
							setWithExpiry( `user_pie_charts_${jwtDecoded.id}`, updateResponse.data.user_charts );

						}
	
						//console.log( updateResponse );
	
					}
	
				} catch( error ) {
					console.log( error );
					return error;
				}
	
				setLoading(false);
	
			})()

		}


	}, [cookies.sustainyou_user_jwt]);

	const handleChartDelete = async ( chartID ) => {

		if ( ! chartID ) return;

		if ( ! cookies.sustainyou_user_jwt ) {
            return;
        }

		const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);

		if ( !jwtDecoded.id ) return;

		let userRequestData = new FormData();
		userRequestData.append( 'token', cookies.sustainyou_user_jwt );
		userRequestData.append( 'chart_id', chartID );
		userRequestData.append( 'type', 'delete' );

		setLoading(true);

		const fetchUrl = `${configVars.apiUrl}sustainchange/v1/getpiecharts/`;

		try{

			const response = await fetch(
				fetchUrl,
				{
				method: "POST",
				headers: {
					Authorization: `Basic ${configVars.auth}`,
				},
				body: userRequestData
				}
			);
			
			const updateResponse = await response.json();
	
			if ( updateResponse ) {

				if ( updateResponse.success === true ) {

					//console.log( updateResponse.data.user_charts );
					
					setUserCharts( updateResponse.data.user_charts );
					setWithExpiry( `user_pie_charts_${jwtDecoded.id}`, updateResponse.data.user_charts );

					window.location.reload();

				}

				//console.log( updateResponse );

			}

		} catch( error ) {
			console.log( error );
			return error;
		}

		setLoading(false);

	}

	return(
		<div className="main-wrapper">
			<Helmet>
				<title>Pie Chart Generator</title>
				<meta name="description" content="" />
			</Helmet>

			<Navigation />

			<div className="page-content-wrap">
				
				<HorizontalNav title="Pie Chart Generator" />

				<div className="pt-5 pt-lg-0 page-content-inner bg-white">
					<div className="mt-5 d-inline-block w-100">

                        <div className="col-12">
                            <div className="p-3 p-lg-4 pb-5 pb-lg-6"  style={{maxWidth: "1440px"}}>

								{loading &&
									<div className="spinner-border" role="status">
										<span className="visually-hidden">Loading...</span>
									</div>
								}

								{!chart_id &&
									<div className="row">
										<div className="col-12 col-lg-9">
											{ userCharts && userCharts.length > 0 &&
												<>
													<h3 className="mb-4">Your Charts</h3>

													{ userCharts.map( (chart, i) => {
														return(
															<div className="row mb-2" key={i}>
																<div className="col-9">
																	<Link to={`/piecharts/${chart.id}`}>{chart.title}</Link>
																</div>
																<div className="col-3">
																	<button type="button" className="btn text-secondary btn-link p-0" onClick={ () => handleChartDelete( chart.id )}> 
																		<i className="fa fa-trash" aria-hidden="true"></i>
																		<span className="ms-2">Tabort</span>
																	</button>
																</div>
															</div>
														);
													})}
												</>
											}
										</div>
										<div className="col-12 col-lg-3">
											<Link to="/piecharts/new">
												<i className="fa fa-plus" aria-hidden="true"></i>
												<span className="ms-2">Create new chart</span>
											</Link>
										</div>
									</div>
								}

								{ chart_id &&
									<ChartGenerator chartID={chart_id} />
								}

                            </div>
                        </div>

						
					</div>

					
				</div>

			</div>

		</div>
	);

}

export default PieCharts;